
import * as THREE from "../../libs/three.js/build/three.module.js";
import {Utils} from "../utils.js";
import {Gradients} from "./Gradients.js";
import {Shaders} from "../../build/shaders/shaders.js";
import {ClassificationScheme} from "./ClassificationScheme.js";
import {PointSizeType, PointShape, TreeType, ElevationGradientRepeat} from "../defines.js";
import {Features} from "../Features.js";
import {PointCloudMaterial} from './PointCloudMaterial.js'
import Common from "../custom/utils/Common.js";
import math from "../custom/utils/math.js";

//
// how to calculate the radius of a projected sphere in screen space
// http://stackoverflow.com/questions/21648630/radius-of-projected-sphere-in-screen-space
// http://stackoverflow.com/questions/3717226/radius-of-projected-sphere
//


export class ExtendPointCloudMaterial extends PointCloudMaterial {
	constructor (parameters = {}) {
		super(parameters);
 

		let getValid = (a, b) => {
			if(a !== undefined){
				return a;
			}else{
				return b;
			}
		}
 
		let maxSize = getValid(parameters.maxSize, 200.0);
        let orthoMaxSize = getValid(parameters.orthoMaxSize, 3.0);
		this._gradient = Gradients.ir   //Gradients.SPECTRAL;//海拔贴图种类,火灾也是这个
		this.gradientTexture = ExtendPointCloudMaterial.generateGradientTexture(this._gradient); 
        this.classificationName = null
        
        delete this.uniforms.screenWidth
        delete this.uniforms.screenHeight
        delete this.uniforms.clipBoxes
        delete this.uniforms.clipPolygons
        delete this.uniforms.clipPolygonVCount
        delete this.uniforms.clipPolygonVP
        delete this.uniforms.clipBoxCount
        
        //注意：这里修改了uniforms后，还需要在PotreeRender中手动传递到shader, like: gl.uniformMatrix4fv(....
        Object.assign(this.uniforms,{
            resolution:    { type: 'v2',  value: new THREE.Vector2() },
            maxSize:			{ type: "f", value: maxSize },
            orthoMaxSize:			{ type: "f", value: orthoMaxSize },
            gradient:			{ type: "t", value: this.gradientTexture },
            
            clipBoxes_in:  { type: "Matrix4fv", value: [] },
            clipBoxes_out:  { type: "Matrix4fv", value: [] },
            clipBoxBig_in:  { type: "Matrix4fv", value: [] },
            boxes_highlight:  { type: "Matrix4fv", value: [] },
			progress: {
				type: "f",
				value: 0
			},
            easeInOutRatio:{
                type: "f",
				value: 0.3
            },
			pano0Map: {
				type: "t",
				value: null
			},
			pano0Position: {
				type: "v3",
				value: new THREE.Vector3
			},
			pano0Matrix: {
				type: "m4",
				value: new THREE.Matrix4
			},
			pano1Map: {
				type: "t",
				value: null
			},
			pano1Position: {
				type: "v3",
				value: new THREE.Vector3
			},
			pano1Matrix: {
				type: "m4",
				value: new THREE.Matrix4
            },   
            
            prismList: {
				type: "Matrix3fv",
				value:  null
			},
            prismPoints: {
				type: "vec2fv",
				value: null
			},
            
            
            baseHeightAreaMap:{
                type:'t',
                value:null
            },
            
            baseHeightBoundZ:{
                type:'vec2',
                value:new THREE.Vector2
            },
            
            baseHeightBoundXY:{
                type:'vec4',
                value:new THREE.Vector4
            },
            temperRange:{//温度范围
                type:'vec2',
                value: new THREE.Vector2(math.getKelvinFromCelsius(99),  math.getKelvinFromCelsius(1500)  ) //火场温度
            }
        })
        
        delete this.clipBoxes;
        
        this.clipBoxes_in = [];
        this.clipBoxes_out = [];
        this.highlightBoxes = [];
		this.prisms = []
        
        let {vs, fs} = Common.changeShaderToWebgl2(Shaders['pointcloud_new.vs'],Shaders['pointcloud_new.fs'], 'selfBuild' )
        Shaders['pointcloud_new.vs'] = vs
        Shaders['pointcloud_new.fs'] = fs
        {
            let setClass = ()=>{
                this.classification = viewer.classifications
                this.recomputeClassification()
            }
            viewer.addEventListener('classifications_changed',setClass)
            viewer.addEventListener('classification_visibility_changed',setClass)
            setClass()
        }
        
        
        
        
        
		this.updateShaderSource();
	}
    
    /* get classificationName(){
        return this.classificationName_
    }
 
    set classificationName(name){//add
        if(this.classificationName_ != name){
            this.classificationName_ = name
            this.classification = ClassificationScheme[name]
            this.recomputeClassification();
        }
    } */

	updateShaderSource () {  

        let vs = Shaders['pointcloud_new.vs']; //改
		let fs = Shaders['pointcloud_new.fs']; //改
		let definesString = this.getDefines();

		let vsVersionIndex = vs.indexOf("#version ");
		let fsVersionIndex = fs.indexOf("#version ");

		if(vsVersionIndex >= 0){
			vs = vs.replace(/(#version .*)/, `$1\n${definesString}`)
		}else{
			vs = `${definesString}\n${vs}`;
		}

		if(fsVersionIndex >= 0){
			fs = fs.replace(/(#version .*)/, `$1\n${definesString}`)
		}else{
			fs = `${definesString}\n${fs}`;
		}

		this.vertexShader = vs;
		this.fragmentShader = fs;

		if (this.opacity === 1.0 && !this.useFilterByNormal) {//add useFilterByNormal
			this.blending = THREE.NoBlending;
			this.transparent = false;
			this.depthTest = true;
			this.depthWrite = true;
			this.depthFunc = THREE.LessEqualDepth;
		} else if (  (this.opacity < 1.0 ||this.useFilterByNormal) &&   !this.useEDL) {//add useFilterByNormal
			this.blending = THREE.AdditiveBlending;
			this.transparent = true;
			this.depthTest = false;
			this.depthWrite = true;
			this.depthFunc = THREE.AlwaysDepth;
		}

		if (this.weighted) {
			this.blending = THREE.AdditiveBlending;
			this.transparent = true;
			this.depthTest = true;
			this.depthWrite = false;
		}

		this.shaderNeedsUpdate = true;
	}

	getDefines () {
		let defines = [];
 
		if (this.pointSizeType === PointSizeType.FIXED) {
			defines.push('#define fixed_point_size');
		} else if (this.pointSizeType === PointSizeType.ATTENUATED) {
			defines.push('#define attenuated_point_size');
		} else if (this.pointSizeType === PointSizeType.ADAPTIVE) {
			defines.push('#define adaptive_point_size');
		}
        
        if(!Features.EXT_DEPTH.isSupported(viewer.renderer.getContext()) && this.shape === PointShape.PARABOLOID){
            this.shape = PointShape.SQUARE ;//强行替换
        }
        
        
		if (this.shape === PointShape.SQUARE) {
			defines.push('#define square_point_shape');
		} else if (this.shape === PointShape.CIRCLE) {
			defines.push('#define circle_point_shape');
		}  else if (this.shape === PointShape.PARABOLOID) { 
			defines.push('#define paraboloid_point_shape');
		}  
        //console.log('this.shape PARABOLOID', this.shape, this.shape === PointShape.PARABOLOID)

		if (this._useEDL || this.fakeEDL) {
			defines.push('#define use_edl');
		}

		if(this.activeAttributeName){
			let attributeName = this.activeAttributeName.replace(/[^a-zA-Z0-9]/g, '_');

			defines.push(`#define color_type_${attributeName}`);
		}
		
		if(this._treeType === TreeType.OCTREE){
			defines.push('#define tree_type_octree');
		}else if(this._treeType === TreeType.KDTREE){
			defines.push('#define tree_type_kdtree');
		}

		if (this.weighted) {
			defines.push('#define weighted_splats');
		}

		for(let [key, value] of this.defines){
			defines.push(value);
		}

		return defines.join("\n");
	}

	 

	  
	get pointSizeType () {
		return this._pointSizeType;
	}
 
 

	set pointSizeType (value) {
        
        if(typeof value == 'string' )value = PointSizeType[value]
        super.pointSizeType = value
		/* if (this._pointSizeType !== value) {
			this._pointSizeType = value;
			this.updateShaderSource();              //这句表明这个属性频繁更改会卡顿
			this.dispatchEvent({
				type: 'point_size_type_changed',
				target: this
			});
			this.dispatchEvent({
				type: 'material_property_changed',
				target: this
			});
		} */
	}

	 
    get color () {
		return this.uniforms.uColor.value;
	}
     

	set color (value) {//改
        
        if(value == this.color_)return
        let color = value;
		//if (!this.uniforms.uColor.value.equals(value)) {
        if(typeof value == 'string') {
            var colorArr = Potree.config.colors[value]  
            if(!colorArr){ 
                //console.warn('没找到该颜色值'+ value)
            }else{
                color = new THREE.Color().fromArray(colorArr).multiplyScalar(1/255)
            }                
            
        }    
        this.uniforms.uColor.value.set(color)  
        //this.uniforms.uColor.value.copy(value);
			
        this.dispatchEvent({
            type: 'color_changed',
            target: this
        });
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this
        });
		//}
        
        this.color_ = value //记录下str
	}

	 
	 
	
	 
	 

    ////////////////////////add
    setProjectedPanos(pano0, pano1, progressValue, easeInOutRatio){
        
        //this.uniforms.usePanoMap.value = 1
        this.usePanoMap = true
        
 		progressValue!=void 0 && (this.uniforms.progress.value = progressValue);
		//pano0.ensureSkyboxReadyForRender();
		this.uniforms.pano0Map.value = pano0.getSkyboxTexture()
		this.uniforms.pano0Position.value.copy(pano0.position)
		this.uniforms.pano0Matrix.value.copy(pano0.panoMatrix  );
		//pano1.ensureSkyboxReadyForRender();
 
        this.uniforms.easeInOutRatio.value =  easeInOutRatio || 0; //之前做点云和全景混合时加的，为了让点云颜色柔和切换到全景颜色。如不混合就0
		
		this.uniforms.pano1Map.value = pano1.getSkyboxTexture()
		this.uniforms.pano1Position.value.copy(pano1.position)
		this.uniforms.pano1Matrix.value.copy(pano1.panoMatrix   );
           
        //this.updateShaderSource()
        //this.needsUpdate = true;
 	}
    stopProjectedPanos(){
        //this.uniforms.usePanoMap.value = 0
        this.usePanoMap = false
    } 

	 
    
	setClipBoxes (bigClipInBox, clipBoxes_in, clipBoxes_out, highlightBoxes, prismPolygons=[]) {
		if (!clipBoxes_in || !clipBoxes_out) {
			return;
		}
 
        
		this.uniforms.clipBoxBig_in.value = bigClipInBox && bigClipInBox.inverse
		this.uniforms.clipBoxes_in.value = new Float32Array(clipBoxes_in.length * 16);
		this.uniforms.clipBoxes_out.value = new Float32Array(clipBoxes_out.length * 16);
		this.uniforms.boxes_highlight.value = new Float32Array(highlightBoxes.length * 16);
        
        
        
		for (let i = 0; i < clipBoxes_in.length; i++) {
			let box = clipBoxes_in[i];  
			this.uniforms.clipBoxes_in.value.set(box.inverse.elements, 16 * i);
		}
		for (let i = 0; i < clipBoxes_out.length; i++) {
			let box = clipBoxes_out[i];  
			this.uniforms.clipBoxes_out.value.set(box.inverse.elements, 16 * i);
		}
		for (let i = 0; i < highlightBoxes.length; i++) {
			let box = highlightBoxes[i];  
			this.uniforms.boxes_highlight.value.set(box.inverse.elements, 16 * i);
		}


		/* for (let i = 0; i < this.uniforms.clipBoxes.value.length; i++) {？？
			if (Number.isNaN(this.uniforms.clipBoxes.value[i])) {
				this.uniforms.clipBoxes.value[i] = Infinity;
			}
		} */
         
  
        if(prismPolygons.length){  
            let pointsCount = prismPolygons.pointsCount = prismPolygons.reduce((w,c)=>{return w+c.points.length},0) 
            this.uniforms.prismList.value = new Float32Array(9 * prismPolygons.length); 
            this.uniforms.prismPoints.value = new Float32Array(2 * pointsCount);
            
            prismPolygons.maxPointsCount = 0//单个prism最大点个数 
             
            
            
            let pointIndex = 0
            for(let i=0;i<prismPolygons.length;i++ ){ 
                let bound = prismPolygons[i].prismBound 
                let z = prismPolygons[i].horizonZ 
                //z = Potree.browser.urlHasValue('zmin',true) ||  zs[0]  
                 
                this.uniforms.prismList.value.set([bound.min.z, z, bound.max.z, bound.min.x, bound.max.x, bound.min.y, bound.max.y,  prismPolygons[i].points.length ],9*i)
                for(let j=0;j<prismPolygons[i].points.length;j++){
                    this.uniforms.prismPoints.value.set([prismPolygons[i].points[j].x, prismPolygons[i].points[j].y] , 2*j+pointIndex);
                }  
                pointIndex += 2 * prismPolygons[i].points.length
                
                
                prismPolygons.maxPointsCount = Math.max(prismPolygons.maxPointsCount, prismPolygons[i].points.length) 
            }
            
            
            
            
        }  
         
        let doUpdate = (this.clipBoxes_in.length !== clipBoxes_in.length) || (this.clipBoxes_out.length != clipBoxes_out.length)
                    || this.highlightBoxes.length !== highlightBoxes.length 
                    || !this.bigClipInBox != !bigClipInBox 
                    || (this.prisms.length != prismPolygons.length) || this.prisms.maxPointsCount != prismPolygons.maxPointsCount                                                                                                                                                                                                                                                                                                                                                                              
		//this.clipBoxes = clipBoxes; 
		if (doUpdate){
			this.shaderNeedsUpdate = true 
            viewer.dispatchEvent('content_changed')
		} 
        
        
        this.bigClipInBox = bigClipInBox
        this.clipBoxes_in = clipBoxes_in
        this.clipBoxes_out = clipBoxes_out
        this.highlightBoxes = highlightBoxes
        this.prisms = prismPolygons
	}
    
    setTempRange(min,max){//温度范围
        this.uniforms.temperRange.value.set(math.getKelvinFromCelsius(min),math.getKelvinFromCelsius(max)) 
    }

    
}
